/* Show consent only after the initial frame and content entrance settle. */
(() => {
  const root=document.documentElement;
  root.classList.add('ak-privacy-waiting');
  function loadEligibleBanner() {
    // Shopify's first automatic initialization can precede its visitor state.
    // Retry after our intro; loadBanner keeps Shopify's saved-consent and
    // regional eligibility checks (unlike force-showing the dialog).
    let attempts=0;
    const retry=()=>{
      if(document.querySelector('#shopify-pc__banner')) return;
      const banner=window.privacyBanner;
      if(typeof banner?.loadBanner==='function') {
        Promise.resolve(banner.loadBanner()).catch(()=>{});
        return;
      }
      if(++attempts<80) setTimeout(retry,250);
    };
    retry();
  }
  function boot() {
    const mobile=matchMedia('(max-width:1200px)');
    const watched=new WeakSet();
    let frame=0,quiet=0,done=false;
    const events=['ak:boot-revealed','ak:global-frame-ready','ak:home-frame-ready','ak:papers-editorial-cta-ready','ak-mobile-product-intro-complete','animationend','transitionend','pageshow','resize'];
    function schedule() {
      if(done) return;
      clearTimeout(quiet);
      if(!frame) frame=requestAnimationFrame(check);
    }
    function pending() {
      const body=document.body;
      if(!root.classList.contains('ak-boot-revealed')) return true;
      if(body.matches('.ak-global-frame-pending,.ak-home-shell-pending,.ak-collection-list-pending,.ak-kingpong-list-pending')) return true;
      if(body.matches('.ak-page-index,.ak-papers-front-page')) {
        const first=document.querySelector('section.ak-featured-carousel');
        if(first && !first.classList.contains('ak-images-visible')) return true;
      }
      if(!mobile.matches && document.querySelector('[data-ak-paper-intro]:not([data-ak-paper-intro="done"])')) return true;
      if(mobile.matches) {
        const astro=document.querySelector('[data-ak-astro]');
        if(astro && astro.dataset.astroEntry!=='done') return true;
        const list=document.querySelector('[data-ak-collection-entrance]');
        if(list && list.dataset.akCollectionEntrance!=='done') return true;
        const product=document.querySelector('[data-ak-mobile-product-intro]');
        if(product && product.dataset.akMobileProductIntro!=='complete') return true;
      }
      return false;
    }
    function moving() {
      let active=false;
      for(const animation of document.getAnimations()) {
        if(animation.playState!=='running' && !animation.pending) continue;
        const timing=animation.effect?.getComputedTiming();
        if(!timing || !Number.isFinite(timing.endTime)) continue;
        let target=animation.effect.target;
        if(!(target instanceof Element)) target=target?.element;
        if(!target || target.closest('#shopify-pc__banner,#shopify-pc__prefs')) continue;
        const rect=target.getBoundingClientRect();
        if(!rect.width || !rect.height || rect.bottom<=0 || rect.top>=innerHeight) continue;
        active=true;
        if(!watched.has(animation)) {
          watched.add(animation);
          animation.finished.then(schedule,schedule);
        }
      }
      return active;
    }
    function check() {
      frame=0;
      if(pending() || moving()) return;
      // Let the next intro phase register before declaring the page settled.
      quiet=setTimeout(()=>{
        if(pending() || moving()) return;
        done=true;
        observer.disconnect();
        events.forEach(event=>window.removeEventListener(event,schedule,true));
        root.classList.remove('ak-privacy-waiting');
        loadEligibleBanner();
      },250);
    }
    const observer=new MutationObserver(schedule);
    observer.observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['class','data-ak-paper-intro','data-astro-entry','data-ak-collection-entrance','data-ak-mobile-product-intro','data-ak-mobile-stage']});
    events.forEach(event=>window.addEventListener(event,schedule,true));
    document.fonts?.ready.then(schedule);
    schedule();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
})();
